export default "__VITE_ASSET__BOm8W7Gm__"